import type * as t from "~/types";
import type { Sequence, SequenceNode } from "~/sequence";

import { getContext, setContext } from "svelte";
import { writable, type Writable } from "svelte/store";

import { createActions } from "~/quiz-actions";
import { EventEmitter } from "~/event-emitter";
import { Telemetry } from "~/telemetry";

export type State = {
    config: t.QuizConfig;
    score: Record<number, number>;
    globalStepIdx: number;
    segments: Sequence<t.Segment>;
    segment: SequenceNode<t.Segment>;
    step: SequenceNode<t.Step>;
    totalSteps: number;
    emailMarketingConfig: t.ShopifyProps["emailMarketingConfig"];
    shop: t.ShopifyProps["shop"];
    status: "initial" | "started";
    instanceId: string;
    presentationStyle: t.QuizProps["presentationStyle"];
    minigameResult?: t.QuizResult;
};

export type QuizContext = {
    state: Writable<State>;
    hooks: ReturnType<typeof createActions>["hooks"];
    actions: ReturnType<typeof createActions>["actions"];
    events: EventEmitter;
    telemetry: Telemetry;
};

export function createAppContext(initialState: State) {
    const state = writable<State>(initialState);
    const telemetry = new Telemetry();
    const events = new EventEmitter();
    const { actions, hooks } = createActions(state, telemetry, events);
    const store: QuizContext = {
        state,
        hooks,
        actions,
        events,
        telemetry,
    };

    setContext("quiz-context", store);

    return store;
}

export function getAppContext() {
    return getContext<QuizContext>("quiz-context");
}
